module.exports = __webpack_public_path__ + "img/right-arm.1e60d06b.png";